(() => {
  if (window.__shefaVitrineAutoscrollLoaded) return;
  window.__shefaVitrineAutoscrollLoaded = true;

  const SELECTOR = 'slider-component[data-shefa-autoscroll="true"]';

  const setup = (component) => {
    if (!component || component.dataset.shefaAutoscrollInitialized === 'true') return;
    const track = component.querySelector('[id^="Slider-"]');
    if (!track) return;

    component.dataset.shefaAutoscrollInitialized = 'true';

    const delay = Math.max(2000, Number(component.dataset.shefaAutoscrollDelay) || 4000);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let timer = null;
    let paused = false;
    let inView = true;
    let resumeTimer = null;

    const getSlides = () => Array.from(track.querySelectorAll('.slider__slide')).filter((slide) => slide.offsetWidth > 0);

    const advance = () => {
      if (paused || !inView || document.hidden || reducedMotion.matches) return;
      if (track.scrollWidth <= track.clientWidth + 4) return;

      const slides = getSlides();
      if (slides.length < 2) return;

      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      if (track.scrollLeft >= maxScroll - 6) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }

      const nextSlide = slides.find((slide) => slide.offsetLeft > track.scrollLeft + 6);
      track.scrollTo({
        left: nextSlide ? Math.min(nextSlide.offsetLeft, maxScroll) : 0,
        behavior: 'smooth',
      });
    };

    const start = () => {
      if (timer || reducedMotion.matches) return;
      timer = window.setInterval(advance, delay);
    };

    const stop = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    const pause = () => {
      paused = true;
      if (resumeTimer) window.clearTimeout(resumeTimer);
    };

    const resume = (wait = 900) => {
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => { paused = false; }, wait);
    };

    component.addEventListener('mouseenter', pause);
    component.addEventListener('mouseleave', () => resume(500));
    component.addEventListener('focusin', pause);
    component.addEventListener('focusout', () => resume(700));
    track.addEventListener('pointerdown', pause, { passive: true });
    track.addEventListener('pointerup', () => resume(1400), { passive: true });
    track.addEventListener('touchend', () => resume(1600), { passive: true });

    component.querySelectorAll('.slider-button, .slider-counter__link').forEach((control) => {
      control.addEventListener('click', () => {
        pause();
        resume(1800);
      });
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        inView = entries[0]?.isIntersecting ?? true;
      }, { threshold: 0.08 });
      observer.observe(component);
    }

    reducedMotion.addEventListener?.('change', () => {
      if (reducedMotion.matches) stop();
      else start();
    });

    start();
  };

  const init = (root = document) => {
    root.querySelectorAll?.(SELECTOR).forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
